// SocialLoginRegistrer.jsx


import googleicon from "../../header/images/googleicon.png";
import facebookicon from "../../header/images/facebookicon.png";
import linkedinicon from "../../imagesHome/share-linkedin.png";

import "./socialloginregistrer.css";

const apiUrl = process.env.REACT_APP_API_URL;


  const handleLinkedInLogin = () => {
    window.location.href = `${apiUrl}/auth/linkedin?flow=register`;
  };


const SocialLoginRegistrer = () => {
  const handleGoogleLogin = () => {
    window.location.href = `${apiUrl}/auth/google?flow=register`;
  };

  const handleFacebookLogin = () => {
    window.location.href = `${apiUrl}/auth/facebook`;
  };

  return (
    <div className="options-connect-registrer">
      {/* Google */}
      <div
        className="connect-social-registrer google-registrer"
        onClick={handleGoogleLogin}
      >
        <img src={googleicon} alt="google icon" />
        <span>Inregistrare cu Google</span>
      </div>

      {/* Linkedin */}
    
      <div className="connect-social-registrer fcbook-registrer" onClick={handleLinkedInLogin}>
              <img src={linkedinicon} alt="linkedin icon" />
              <span>Inregistrare cu LinkedIn</span>
            </div>


    </div>
  );
};

export default SocialLoginRegistrer;
